﻿import { createContext, useContext as useReactContext } from 'react';

import type { UsersContextValue } from 'pages/users/SystemAdministratorsWrapper';
import { DEFAULT_TAB_CONTEXT, TabsContext, useContext } from 'components/Tabs';
import { User } from 'apis/UsersApi';

export type UserData = {
    userDetails?: User;
    userDetailsOriginal?: User;
}

export const UserDetailsContext = createContext<TabsContext<UserData>>(DEFAULT_TAB_CONTEXT);
UserDetailsContext.displayName = 'UserDetailsContext';

export const useUserDetails = () => useContext(UserDetailsContext);

export const UsersContext = createContext<UsersContextValue>({
    currentPartnerId: 0,
    permissions: {
        Authenticate: false,
        Edit: false, // Partner Edit permission
        UserEdit: false,
        UserView: false
    }
});
UsersContext.displayName = 'UsersContext';

export const useUsers = () => useReactContext(UsersContext);